(function ($) {

  Drupal.behaviors.mpp = {
    attach: function (context, settings) {
      //insert touts between the mpp product grids.
      if (Drupal.settings.globals_variables && typeof Drupal.settings.globals_variables.enable_inline_tout !== 'undefined' && Drupal.settings.globals_variables.enable_inline_tout === true) {
        var $products = $('.mpp__product', context);
        var $toutWrapper = $('.js-mpp_tout', context);
        var $productGridTout = $('.js-product-grid__tout', context);
        var inlinePosition = 0;
        $toutWrapper.each(function(i) {
          var $this = $(this);
          var $listSelector, $tout, $img;
          inlinePosition = $this.data('position') - 1;
          //Check whether content block exists
          if ($this.find($productGridTout).length > 0) {
            if (!isNaN(inlinePosition)) {
              // Creating a li dom and moving the existing dom so that it does not break its existing js events.
              $tout = $('<li/>').attr({
                'class': 'mpp__product product-grid-custom__tout',
                'data-position': inlinePosition,
              }).append($this.children());
              $listSelector = $products.eq(inlinePosition - i);
              $tout.insertBefore($listSelector);
              $img = $tout.find('img:visible');
              $img.load(function() {
                $(this).addClass('fadeElemIn');
              });
            }
          }
        });
      }
      var productsArray = page_data['catalog-mpp'].categories[0].products;

      $(".js-product-brief").each( function() {
        var productId = $(this).attr('data-product-id');
        var productData = _.find(productsArray, function(p){ return p.PRODUCT_ID == productId; });
        site.product.view.brief({
          containerNode: this,
          productData: productData
        });
        //ie8 pie attach behavior
        if ( generic.env.isIE8 ) {
          if (window.PIE) {
            $('.swatches--single div').each(function(i, el) {
              PIE.attach(this);
            });
          }
        }
      });

      // adding tooltip to shade select button
      $(".product_brief__button-panel.button-color-picker").each(function() {
        $(this).hover(function() {
          // PHF 20150731 1645 i230637: on iPad, hover is a tap... so it takes two
          // taps to get to the color pallet.  THis condition gets us there in one.
          var isiPad = /ipad/i.test(navigator.userAgent.toLowerCase());
          if (!isiPad) {
            $(this).append('<div class="tooltip"><p>'+ site.selectShade + '</p></div>');
          }
        }, function() {
          $("div.tooltip").remove();
        });
      });

      site.product.view.miscFlagAlign($('.mpp__product'));
      site.product.view.equalRowHeight($('.mpp__product'));
      $('.mpp__product-grid .mpp__product:nth-child(3n+2)').addClass('nth-child-3np2');

      //quickshop test
      function getUrlVars() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for(var i = 0; i < hashes.length; i++) {
          hash = hashes[i].split('=');
          vars.push(hash[0]);
          vars[hash[0]] = hash[1];
        }
        return vars;
      }
      var qs = getUrlVars()['qs'];
      if(qs){
        $('.qs_test').removeClass('hidden');
        $('.qs_test').click(function(event) {
          var pid = $(this).attr('data-product-id');
          var quickshopData = _.find(productsArray, function(p){ return p.PRODUCT_ID == pid; });
          site.quickshop(quickshopData);
        });
      //$('.qs_test').eq(1).trigger('click');
      }

      // Procuct Sort
      site.productSort.init(productsArray);
      // Product compare nav
      // check function before calling it
      if (typeof site.mppCompareInit === 'function') {
        site.mppCompareInit(productsArray);
      }
      else {
        //console.log('Error site.mppCompareInit is not a function');
      }
      // Personalization MPP initialization
      if ( Drupal.ELB.hasPersonalization() ) {
        site.profile.pc.MPP(page_data['catalog-mpp']);
      };

    }
  };



})(jQuery);
